import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import mixColorWithWhite from "../../TreatmentPage/utils/helperFn";
import { formatDateForPanelDisplay } from "../../../Utils/helper";
import UserChatBubble from "../../Forms/FirmUserBtn";
import { useDocumentModal } from "../../common/CustomModal/CustomModalContext";

// Function to render data rows
const renderDataRow = (trRef, tableRowStyle, doc, index, userOnlineStatus, handleDocPreview) => {
  return (
    <tr
      ref={(el) => (trRef.current[index] = el)}
      key={`defendant-${index}`}
      className="defendant-height-205"
      onClick={() => handleDocPreview(doc)}
      style={tableRowStyle}
    >
      <td
        className="text-center"
        style={{
          minWidth: "25px",
          width: "25px",
          maxWidth: "25px",
          color: "var(--primary-25)",
          fontWeight: "600",
        }}
      >
        {index + 1}
      </td>

      <td className="td-autosize p-l-5">
        <div className="d-flex p-l-5 align-items-center">
          <span
            className=" d-flex align-items-center"
            style={{
              fontWeight: "600",
              gap: "5px",
            }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "100px",
              }}
            >
              <img
                style={{
                  width: "100px",
                  height: "63px",
                  objectFit: "contain",
                }}
                src={doc?.image}
              />
            </div>
            {doc?.title}
          </span>
        </div>
      </td>
      <td />
      <td>
        <div
          style={{
            fontWeight: "600",
            textTransform: "lowercase",
          }}
          className="d-flex align-items-center text-center justify-content-center"
        >
          {doc?.photo_size ?? ""}
        </div>
      </td>
      <td />

      <td className=" p-l-5">
        <div>
          {doc?.photo_slot?.slot_number === 0 && (
            <>
              <>
                <div
                  className="height-21 d-flex align-items-center p-r-5"
                  style={{
                    fontWeight: "600",
                    gap: "5px",
                  }}
                >
                  {doc?.page?.page_icon && (
                    <span
                      className="d-flex align-items-center justify-content-end"
                      style={{
                        width: "21px",
                        height: "21px",
                      }}
                    >
                      <img src={doc?.page?.page_icon} className="ic ic-docs ic-15" />
                    </span>
                  )}

                  <>{doc?.page?.name}</>
                </div>
                <div
                  className="height-21 d-flex align-items-center p-r-5"
                  style={{
                    fontWeight: "600",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      width: "21px",
                      minWidth: "21px",
                    }}
                    className="text-end"
                  >
                    {/*  */}
                  </span>
                  Linked to
                </div>
                <div
                  className="height-21 d-flex align-items-center p-r-5"
                  style={{
                    fontWeight: "600",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{
                      width: "21px",
                      minWidth: "21px",
                    }}
                    className="text-end"
                  >
                    {/* 3: */}
                  </span>
                  Page
                </div>
              </>
            </>
          )}
          {doc?.photo_slot?.slot_number !== 0 && (
            <div
              className="height-21 d-flex align-items-center p-r-5"
              style={{
                fontWeight: "600",
                gap: "5px",
              }}
            >
              {doc?.page?.page_icon && (
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{
                    width: "21px",
                    height: "21px",
                  }}
                >
                  <img src={doc?.page?.page_icon} className="ic ic-docs ic-15" />
                </span>
              )}
              {doc?.photo_slot === null ? (
                <>
                  <span
                    style={{
                      width: "21px",
                      minWidth: "21px",
                    }}
                    className="text-end"
                  >
                    {/* 1: */}
                  </span>
                  Unsorted
                </>
              ) : (
                <>{doc?.page?.name}</>
              )}
              {/* {doc?.page?.name} Page{" "}
            {doc?.photo_slot === null || doc?.photo_slot?.slot_number === 0 ? "Unsorted" : ""} */}
            </div>
          )}
          {doc?.photo_slot === null && (
            <>
              <div
                className="height-21 d-flex align-items-center p-r-5"
                style={{
                  fontWeight: "600",
                  gap: "5px",
                }}
              >
                <span
                  style={{
                    width: "21px",
                    minWidth: "21px",
                  }}
                  className="text-end"
                >
                  {/*  */}
                </span>
                Linked to
              </div>
              <div
                className="height-21 d-flex align-items-center p-r-5"
                style={{
                  fontWeight: "600",
                  gap: "5px",
                }}
              >
                <span
                  style={{
                    width: "21px",
                    minWidth: "21px",
                  }}
                  className="text-end"
                >
                  {/* 3: */}
                </span>
                Case Only
              </div>
            </>
          )}

          {doc?.photo_slot !== null && doc?.photo_slot?.slot_number !== 0 && (
            <div
              style={{
                fontWeight: "600",
              }}
              className="height-21 d-flex align-items-center"
            >
              {doc?.photo_slot === null || doc?.photo_slot?.slot_number === 0 ? (
                `${doc?.page?.name} Page`
              ) : doc?.panel ? (
                doc?.panel?.panel_type === "Treatment" ? (
                  <>
                    <div
                      className="has-primary-font-detail-view-card"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: doc?.panel?.specialty?.color
                          ? mixColorWithWhite(doc?.panel?.specialty?.color, 10)
                          : "var(--primary-15)",
                        fontSize: "14px",
                        fontWeight: "600",
                        height: "21px",

                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span
                        className="d-flex m-r-5 align-items-center justify-content-center"
                        style={{
                          width: "21px",
                          height: "21px",
                          background: doc?.panel?.specialty?.color || "#000",
                          color: "white",
                          minWidth: "21px",
                        }}
                      >
                        {doc?.panel?.specialty?.name?.[0] || "?"}
                      </span>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          fontWeight: "600",
                          height: "21px",
                          alignContent: "center",
                          display: "flex",
                          alignItems: "center",
                          paddingRight: "5px",
                        }}
                      >
                        {doc.panel?.panel_name}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="height-21 d-flex align-items-center p-r-5"
                      style={{
                        fontWeight: "600",
                        gap: "5px",
                      }}
                    >
                      <span
                        className="d-flex align-items-center justify-content-end"
                        style={{
                          width: "21px",
                          height: "21px",
                        }}
                      >
                        {/*  */}
                      </span>

                      <>{doc?.panel?.panel_name} </>
                    </div>
                  </>
                )
              ) : doc?.photo_slot?.slot_number ? (
                <>
                  <span
                    className="d-flex align-items-center justify-content-end m-r-5"
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  >
                    {doc.photo_slot.slot_number}:
                  </span>
                  {`${doc.photo_slot.slot_name ?? doc.title}`}
                </>
              ) : (
                <>
                  <span
                    className="d-flex align-items-center justify-content-end"
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  >
                    {/* {doc.document_slot.slot_number} */}
                  </span>
                  {`${doc?.photo_slot?.slot_name ?? doc?.title}`}
                </>
              )}
            </div>
          )}
          {doc?.panel && (
            <div
              style={{
                fontWeight: "600",
              }}
              className="height-21 d-flex align-items-center"
            >
              {doc?.photo_slot?.slot_number ? (
                <>
                  <span
                    className="d-flex align-items-center justify-content-end m-r-5"
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  >
                    {doc.photo_slot.slot_number}:
                  </span>
                  {`${doc.photo_slot.slot_name ?? doc.title}`}
                </>
              ) : (
                <>
                  <span
                    className="d-flex align-items-center justify-content-end"
                    style={{
                      width: "21px",
                      height: "21px",
                    }}
                  >
                    {/* {doc.document_slot.slot_number} */}
                  </span>
                  {`${doc?.photo_slot?.slot_name ?? doc?.title}`}
                </>
              )}
            </div>
          )}
        </div>
      </td>
      {/* <td className="td-autosize text-start">
      
    </td> */}

      <td />
      <td className="text-end">
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column pe-2"
        >
          {formatDateForPanelDisplay(doc?.date_uploaded)}
        </div>
      </td>
      {/* <td /> */}
      <td className="text-center">
        <div
          style={{
            fontWeight: "600",
          }}
          className="d-flex flex-column align-items-center"
        >
          <UserChatBubble
            userId={doc?.attached_by?.id}
            first_name={doc?.attached_by?.first_name ?? ""}
            last_name={doc?.attached_by?.last_name ?? ""}
            profilePic={doc?.attached_by?.profile_pic_29p ?? ""}
            is_active={doc?.attached_by?.is_active}
            width={19}
            height={25}
            isActive={userOnlineStatus?.[doc?.attached_by?.id]?.isOnline ?? false}
          />
        </div>
      </td>
      <td />
    </tr>
  );
};

const renderEmptyRows = (emptyRowStyle, tableRowStyle, dataLength, fakeRows) => {
  const minRows = fakeRows;
  const emptyRowsCount = Math.max(0, minRows);

  return Array.from({ length: emptyRowsCount }, (_, index) => (
    <tr key={`empty-${index}`} style={tableRowStyle}>
      <td colSpan={14} className="empty-row">
        <div style={emptyRowStyle}>{/* Empty row */}</div>
      </td>
    </tr>
  ));
};

function PhotoSummaryView({ doc = [], containerHeight, refetchData }) {
  const [lineHeight, setLineHeight] = React.useState(25);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const { showDocumentModal } = useDocumentModal();
  const tableRowStyle = {
    height: `${lineHeight}px`,
    lineHeight: `${lineHeight}px`,
  };

  const emptyRowStyle = {
    height: `${lineHeight}px`,
    width: "100%",
  };
  const trRef = useRef([]);
  const [fakeRows, setFakeRows] = useState(0);

  useEffect(() => {
    if (!containerHeight?.current || !trRef?.current) return;

    const height = containerHeight.current.offsetHeight;
    const availableHeight = height - 110;
    const minHeight = lineHeight ?? 25;
    const totalRows = Math.floor(availableHeight / minHeight);
    const availableRows = doc?.results?.length || 0;
    const fake = totalRows - availableRows;
    setFakeRows(fake);
  }, [containerHeight, doc?.results?.length, trRef, lineHeight]);

  useLayoutEffect(() => {
    const heights = trRef.current.map((el) => el?.offsetHeight ?? 25);
    const maxHeight = Math.max(...heights);
    setLineHeight(maxHeight);
  }, [doc]);
  const handleDocPreview = (photo) => {
    // showDocumentModal("photo", photo.image, photo, tabData, refetchData, photo.case_thumbnail);
    showDocumentModal("photo", photo?.image, photo, doc, refetchData, photo?.case_thumbnail);
  };
  return (
    <div className="custom-tab lit-custom-tab w-100 m-b-5">
      {/* Table */}
      <div className="table-responsive overflow-hidden">
        <table className="table table-borderless table-striped table-treatment has-height-25">
          <thead>
            <tr id="tb-header">
              <th
                className="text-center"
                style={{
                  minWidth: "25px",
                  width: "25px",
                  maxWidth: "25px",
                }}
              />

              <th className="td-autosize text-center color-grey-2 p-l-5">Photo Name</th>
              <th />
              <th className="td-autosize text-center color-grey-2">Size</th>
              <th />
              <th className="td-autosize text-center color-grey-2 p-l-5">Location</th>
              {/* <th className="td-autosize text-center color-grey-2">Slot</th> */}
              <th />
              <th className="td-autosize text-center color-grey-2" colSpan={2}>
                Added
              </th>
              {/* <th /> */}
              {/* <th className="td-autosize text-center color-grey-2">Firm User</th> */}
              <th
                style={{
                  minWidth: "5px",
                  maxWidth: "5px",
                  width: "5px",
                }}
              />
            </tr>
          </thead>
          <tbody>
            {doc?.results?.map((doc1, index) =>
              renderDataRow(trRef, tableRowStyle, doc1, index, userOnlineStatus, handleDocPreview)
            )}
            {renderEmptyRows(emptyRowStyle, tableRowStyle, doc?.results?.length || 0, fakeRows)}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default React.memo(PhotoSummaryView);
